import { simulateNativeIF } from "../utils/simulateNativeIF";
import { BridgeParameter } from "../types/bridgeParameter";

declare global {
    interface Window {
        JSBridge: {
            sendEvent(parameter: string): void;
            sendEventReturn(parameter: string): void;
        };
        BrazeBridge: { // Android
            trackingEvent: (stringifiedObject: string) => void;
            trackingAttr: (stringifiedObject: string) => void;
        },
        webkit: {
            messageHandlers: {
                sendEvent: {
                    postMessage(parameter: string): void;
                };
                sendEventReturn: {
                    postMessage(parameter: string): void;
                };
                BrazeBridgeTrackingEvent: {
                    postMessage: (stringifiedObject: string) => void;
                };
                BrazeBridgeTrackingAttr: {
                    postMessage: (stringifiedObject: string) => void;
                };
            };
        };
    }
}

export const sendEvent = async (key: string, param: any) => {
    const parameter: BridgeParameter = {
        type: key,
        param: param,
    };

    try {
        const stringifiedObject = JSON.stringify(parameter);
        if (process.env.REACT_APP_NODE_ENV !== 'production') {
            console.log(stringifiedObject);
        }
    
        if (window.JSBridge && window.JSBridge.sendEvent) {
            window.JSBridge.sendEvent(stringifiedObject);
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sendEvent) {
            window.webkit.messageHandlers.sendEvent.postMessage(stringifiedObject);
        } else {
            console.error('sendEvent bridge is not ready');
        }    
    } catch (error) {
        console.error('Error calling sendEvent:', error);
    }
}

export const sendEventReturn = async (key: string, param: any) => {
    const parameter: BridgeParameter = {
        type: key,
        param: param,
    };
    
    try {
        const stringifiedObject = JSON.stringify(parameter);
        if (process.env.REACT_APP_NODE_ENV !== 'production') {
            console.log(stringifiedObject);
        }
        
        if (window.JSBridge && window.JSBridge.sendEventReturn) {
            window.JSBridge.sendEventReturn(stringifiedObject);
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sendEventReturn) {
            window.webkit.messageHandlers.sendEventReturn.postMessage(stringifiedObject);
        } else {
            // Simulate the response in local environment
            if (await simulateNativeIF(key, param)) {
                return;
            }
            console.error('sendEventReturn bridge is not ready!');
        }
    } catch (error) {
        console.error('Error calling sendEventReturn:', error);
    }
}

export const sendEventToAndroid = (key: string, param: any) => {
    const parameter: BridgeParameter = {
        type: key,
        param: param,
    };

    const stringifiedObject = JSON.stringify(parameter);
    console.log(stringifiedObject);
    if (window.JSBridge && window.JSBridge.sendEvent) {
        window.JSBridge.sendEvent(stringifiedObject);
        // console.log('Android sendEvent bridge called!');
    } else {
        console.error('Android sendEvent bridge is not ready!');
    }
};

export const sendEventReturnToAndroid = (key: string, param: any): any => {
    const parameter: BridgeParameter = {
        type: key,
        param: param,
    };

    if (window.JSBridge && window.JSBridge.sendEventReturn) {
        const stringifiedObject = JSON.stringify(parameter);
        console.log(stringifiedObject)
        window.JSBridge.sendEventReturn(stringifiedObject);
        // console.log('Android sendEventReturn bridge called!');
    } else {
        console.error('Android sendEventReturn bridge is not ready!');
    }
};

export const sendEventToIOS = (key: string, param: any) => {
    const parameter: BridgeParameter = {
        type: key,
        param: param,
    };

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sendEvent) {
        const stringifiedObject = JSON.stringify(parameter);
        window.webkit.messageHandlers.sendEvent.postMessage(stringifiedObject);
        // console.log('iOS sendEvent bridge called');
    } else {
        console.error('iOS sendEvent bridge is not ready');
    }
};

export const sendEventReturnToIOS = (key: string, param: any): any => {
    const parameter: BridgeParameter = {
        type: key,
        param: param,
    };

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sendEventReturn) {
        const stringifiedObject = JSON.stringify(parameter);
        window.webkit.messageHandlers.sendEventReturn.postMessage(stringifiedObject);
        // console.log('iOS sendEventReturn bridge called');
    } else {
        console.error('iOS sendEventReturn bridge is not ready');
    }
};
